import { Component, inject, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { provideCommonAngularModules, provideRouterAngular } from '@share/provideAngularModules';
import { Breadcrumb } from '@share/type';
import { DEFAULT_CURRENT_LANGUAGE } from 'app/common/constants';
import { LanguageService } from 'app/services/language.service';
import { NotificationEventService } from 'app/services/notificationEvent.service';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { AuthService } from '@app/services/auth.service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalService } from 'ng-zorro-antd/modal';
import { LogoutModalComponent } from '../logoutModal/logoutModal.component';
import { ImageAvatarService } from '@app/services/old/imageAvatar.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NzBreadCrumbModule, ...provideRouterAngular(), TranslatePipe, NzSelectModule, NzAvatarModule, NzDropDownModule, NzIconModule, ...provideCommonAngularModules()],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
  notificationEventService: NotificationEventService = inject(NotificationEventService);
  languageService = inject(LanguageService);
  authService = inject(AuthService);
  nzModalService = inject(NzModalService);
  translateService = inject(TranslateService);
  imageAvatarService = inject(ImageAvatarService);
  isCollapsed = false;
  breadcrumbList: Array<Breadcrumb> = [];
  currentLang: string = DEFAULT_CURRENT_LANGUAGE;
  userName: string = '';
  userEmail: string = '';
  imageAvatarUrl: string = '';
  imageAvatarText: string = '';

  constructor() { }



  ngOnInit() {
    const user = this.authService.getUser();
    if (user) {
      this.userName = (user.firstname ? user.firstname.trim() : '') + (user.lastname ? user.lastname.trim() : '');
      this.userEmail = user.email;
      this.imageAvatarText = user.fullname_initial;
      this.imageAvatarUrl = this.imageAvatarService.getImagePhotoUrl(user._id);
    }
    this.notificationEventService.breadcrumbEvent.subscribe((breadcrumbList: Array<Breadcrumb>) => {
      this.breadcrumbList = breadcrumbList;
    });
    this.notificationEventService.languageEvent.subscribe((currentLang: string) => {
      this.currentLang = currentLang
    })
  }

  handleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.notificationEventService.isCollapsedEvent.next(this.isCollapsed);
  }

  handleLanguageChange() {
    this.languageService.useLanguage(this.currentLang, true);
  }

  openUserDetails() {
    if (location.hostname != 'localhost') {
      window.open("/dashboard/#/user-profile", '_blank');
    } else {
      window.open("http://localhost:5505/dashboard/#/user-profile", '_blank');
    }
  }

  logout() {
    const modalRef = this.nzModalService.create({
      nzTitle: this.translateService.instant("CompanyLogOut", {'company': 'GeneX'}),
      nzContent: LogoutModalComponent,
      nzBodyStyle: {
        padding: '0'
      },
      nzCentered: true,
      nzFooter: null,
    })
    modalRef.afterClose.subscribe(result => {
      if (result) {
        window.open("/dashboard/#/login", '_self');
      }
    })
  }
}